import type { FunctionComponent } from "react"

import { TagCTA } from "@jobteaser/ui-kit/components/Tag"

import { useCareerCenterFetch } from "@/modules/careerCenter/hooks/useCareerCenterFetch"
import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { useJobAdsFilterNavigation } from "@/modules/jobAds/client/hooks/useJobAdsFilterNavigation"
import { useJobAdsSearchParams } from "@/modules/jobAds/client/hooks/useJobAdsSearchParams"

type ExclusiveSwitchFilterProps = {
  onChange?: (param: boolean) => void
}

export const ExclusiveSwitchFilter: FunctionComponent<ExclusiveSwitchFilterProps> = ({ onChange }) => {
  const { t } = useTranslation(["companies_client"])
  const searchParams = useJobAdsSearchParams()
  const { navigateWithUpdatedQueryParams } = useJobAdsFilterNavigation()
  const { dataCareerCenter } = useCareerCenterFetch()
  const isSelected = searchParams.has("exclusive")
  const showExclusiveFilter = dataCareerCenter?.intranet

  if (!showExclusiveFilter) return null

  const applyFunctionFilter = (newValue: boolean): void => {
    if (isSelected !== newValue) {
      navigateWithUpdatedQueryParams({ availableFilters: { exclusive: newValue ? "reserved" : "" } })
      onChange?.(newValue)
    }
  }

  return (
    <TagCTA
      isSelected={isSelected}
      onClick={() => applyFunctionFilter(!isSelected)}
      data-testid="job_ads_exclusive_filter_switch"
    >
      {t("companies_client.jobAds.filter.career_center.exclusive", { name: dataCareerCenter.name })}
    </TagCTA>
  )
}
